interface IProps {
    color?: string;
    size?: number;
    onClick?: () => void;
    stoke?: string;
}

export const MemberCrown = (props: IProps) => {
    const { color } = props;
    return (
        <svg
            id="a"
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 20.4 16.35"
        >
            <rect
                className="b"
                x="2.43"
                y="13.92"
                width="15.38"
                height="2.43"
                rx="1.21"
                ry="1.21"
                fill={color || "#fff"}
            />
            <path
                className="c"
                d="M12.22,2.1c0,.99-.69,1.83-1.62,2.05,.2,1.35,.84,3.91,2.91,4.27,2.14,.37,3.63-2.18,4.24-3.44-.36-.3-.59-.75-.59-1.25,0-.89,.72-1.62,1.62-1.62s1.62,.72,1.62,1.62-.72,1.62-1.62,1.62c-.11,0-.22-.01-.32-.03l-1.62,7.97H3.4L1.78,5.33c-.05,0-.11,0-.16,0-.89,0-1.62-.72-1.62-1.62s.72-1.62,1.62-1.62,1.62,.72,1.62,1.62c0,.56-.28,1.05-.71,1.34,.63,1.29,2.1,3.71,4.19,3.35,2.07-.35,2.71-2.91,2.91-4.27-.93-.22-1.62-1.05-1.62-2.05,0-1.16,.94-2.1,2.1-2.1s2.1,.94,2.1,2.1ZM6.96,11.66c.45,0,.81-.36,.81-.81s-.36-.81-.81-.81-.81,.36-.81,.81,.36,.81,.81,.81Zm4.05-.81c0,.45-.36,.81-.81,.81s-.81-.36-.81-.81,.36-.81,.81-.81,.81,.36,.81,.81Zm2.43,.81c.45,0,.81-.36,.81-.81s-.36-.81-.81-.81-.81,.36-.81,.81,.36,.81,.81,.81Z"
                fill={color || "#fff"}
            />
        </svg>
    );
};
